

import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import { AdvancedSearchFilter, DataType } from "@/types"
import { CaseColumn } from "@/types/caseColumns"
import { Operator, operatorLabels, operatorsByFieldType } from "@/types/insights/operators"

import moment from "moment"

import api from "@/services/api"
import vSelect from "vue-select"
import ParameterValue from "@/components/Controls/ParameterValue.vue"
import DataSourceSelect from "@/components/Fields/DataSourceSelect.vue"
import { SearchClauseParameters } from "@/types/view"

@Component({
	components: {
		"data-select": DataSourceSelect,
		"v-select": vSelect,
		"parameter-value": ParameterValue,
		"column-filters": () => import("./ColumnFilters.vue")
	}
})
export default class SearchFilter extends Vue {
	@Prop()
	value!: AdvancedSearchFilter;

	@Prop()
	allCaseFields!: CaseColumn[];

	@Prop({ default: () => [] })
	public filterColumnGroups!: CaseColumn[][]

	@Prop()
	field!: CaseColumn;

	filterValues: any[] = [];
	filterSelectedValue: any = null;
	operator = Operator; // use enum value in markup

	get filterOperators (): any[] {
		if (!this.value || !this.value.columnDataType) {
			return []
		}

		const fieldTypeOperators = this.field.operators
			? this.field.operators
			: operatorsByFieldType[this.value.columnDataType]
		return operatorLabels.filter(o => fieldTypeOperators.indexOf(o.operator) > -1)
	}

	get filterLabel (): string {
		if (!this.value) return ""

		if (this.field.fieldDataType === DataType.dateTime) {
			if (this.value.dynamicValue) {
				if (!isNaN(parseInt(this.value.value!))) {
					return "Start of " + this.value.value
				} else {
					return "Today plus " + this.value.value + " days"
				}
			} else if (this.value.operator === Operator.DateRange) {
				const params = this.value.searchClauseParameters
				return params ? `between ${params.startDate!.toLocaleDateString()} and ${params.endDate!.toLocaleDateString()}`
					: ""
			} else {
				return this.value.value ? moment(this.value.value).format("L") : ""
			}
		} else if (this.field.fieldDataType === DataType.timeSpentAsValue) {
			const params = this.value.searchClauseParameters
			return params
				? `${params.timeSpentClause.searchLabel} for ${params.timeSpentClause.hoursSpent} hours`
				: ""
		} else {
			return this.value.label
				? this.value.label
				: this.value.value
					? this.value.value
					: ""
		}
	}

	public async mounted () {
		if (this.value.columnValues) {
			this.filterValues = await this.value.columnValues(api)
			this.filterSelectedValue = this.filterValues.find(v => v.id === this.value.value)
		}
	}

	private updateOperator (newOperator: Operator) {
		if (newOperator === Operator.IsSet || newOperator === Operator.NotSet) {
			this.value.value = ""
			this.value.label = null
		}

		const newOperatorLabel = operatorLabels.find(o => o.operator === newOperator)
		if (newOperatorLabel) {
			this.value.operatorLabel = newOperatorLabel.label
		} else {
			this.value.operatorLabel = ""
		}
	}

	private setFilterValue (newValue: any) {
		if (newValue) {
			this.value.value = newValue.id
			this.value.label = this.value.columnListLabel ? newValue[this.value.columnListLabel] : newValue.label
		} else {
			this.value.value = null
			this.value.label = ""
		}
	}

	private removeFilter () {
		this.$emit("removeFilter")
	}

	searchClauseParametersChanged (clause: any, searchClauseParameters: SearchClauseParameters) {
		Vue.set(clause, "searchClauseParameters", searchClauseParameters)
	}
}

